function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.986.667C6.626.667.666 6.64.666 14s5.96 13.333 13.32 13.333c7.374 0 13.347-5.973 13.347-13.333S21.36.667 13.987.667zm4.4 19.613l-5.72-5.733V7.333h2.667v6.12L20.28 18.4l-1.893 1.88z",
  fill: "#A7A7A7"
});

var SvgClock1 = function SvgClock1(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M13.9865 0.666748C6.6265 0.666748 0.666504 6.64008 0.666504 14.0001C0.666504 21.3601 6.6265 27.3334 13.9865 27.3334C21.3598 27.3334 27.3332 21.3601 27.3332 14.0001C27.3332 6.64008 21.3598 0.666748 13.9865 0.666748ZM18.3865 20.2801L12.6665 14.5467V7.33341H15.3332V13.4534L20.2798 18.4001L18.3865 20.2801Z' fill='%23A7A7A7'/%3E %3C/svg%3E";
export { SvgClock1 as ReactComponent };